import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Urban Blue Infrastructure</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-blue-infrastructure/urban-blue-infrastructure.jpg'} alt={'urban blue infrastructure'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p>{`Shi D, `}<strong parentName="p">{`Song J*`}</strong>{`, Zhong Q, Myint SW, Zeng P, Che Y (2024). `}<Link href={'https://www.sciencedirect.com/science/article/pii/S0034425723004777'} mdxType="Link">{`Cooling wisdom of ‘water towns’: How urban river networks can shape city climate? `}<em parentName="p">{`Remote Sensing of Environment`}</em>{`, 300, 113925.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      